import { createActions, createReducer } from 'reduxsauce'

const situacoesAtivos = [
    { value: '', label: 'Nenhum' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeReferenciaConsultaRemuneracao: ['referencia'],
    removeOrgaoConsultaRemuneracao: ['orgao'],
    removeCargoConsultaRemuneracao: ['cargo'],
    removeVinculoConsultaRemuneracao: ['vinculo'],
    removeFuncionarioConsultaRemuneracao: ['funcionario'],
    removeSetorConsultaRemuneracao: ['setor'],
    removeAtivoConsultaRemuneracao: ['ativo'],
    setMostraAplicarFiltroConsultaRemuneracao: [],
    limpaFiltroConsultaRemuneracao: [],
    aplicarFiltroConsultaRemuneracao: ['filtro'],
})

const INITIAL_STATE = {
    referencia: [],
    orgao: [],
    cargo: [],
    vinculo: [],
    funcionario: '',
    setor: [],
    ativo: { value: situacoesAtivos[0].value, label: situacoesAtivos[0].label },
    mostraAplicarFiltro: false,
}

const removeReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: '', mostraAplicarFiltro: true }
}

const removeOrgao = (state = INITIAL_STATE, action) => {
    return { ...state, orgao: '', mostraAplicarFiltro: true }
}

const removeCargo = (state = INITIAL_STATE, action) => {
    state.cargo.splice(state.cargo.indexOf(action.cargo), 1)

    state.cargo = Array.from(state.cargo)
    return { ...state, mostraAplicarFiltro: true }
}

const removeVinculo = (state = INITIAL_STATE, action) => {
    return { ...state, vinculo: '', mostraAplicarFiltro: true }
}

const removeFuncionario = (state = INITIAL_STATE, action) => {
    return { ...state, funcionario: '', mostraAplicarFiltro: true }
}

const removeSetor = (state = INITIAL_STATE, action) => {
    state.setor.splice(state.setor.indexOf(action.setor), 1)

    state.setor = Array.from(state.setor)
    return { ...state, mostraAplicarFiltro: true }
}

const removeAtivo = (state = INITIAL_STATE, action) => {
    return { ...state, ativo: { value: situacoesAtivos[0].value, label: situacoesAtivos[0].label }, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_REFERENCIA_CONSULTA_REMUNERACAO]: removeReferencia,
    [Types.REMOVE_ORGAO_CONSULTA_REMUNERACAO]: removeOrgao,
    [Types.REMOVE_CARGO_CONSULTA_REMUNERACAO]: removeCargo,
    [Types.REMOVE_VINCULO_CONSULTA_REMUNERACAO]: removeVinculo,
    [Types.REMOVE_FUNCIONARIO_CONSULTA_REMUNERACAO]: removeFuncionario,
    [Types.REMOVE_SETOR_CONSULTA_REMUNERACAO]: removeSetor,
    [Types.REMOVE_ATIVO_CONSULTA_REMUNERACAO]: removeAtivo,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_REMUNERACAO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_REMUNERACAO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_REMUNERACAO]: aplicarFiltro,
})
